module.exports = __webpack_public_path__ + "static/media/carousel-img2.fe51f817.png";